import { fetchData, ENDPOINT_HOST } from './api_helper';

const apiURL = `${ENDPOINT_HOST}statements`;

const fetchStatements = (page, searchTerm = '', locationIds, categoryId, hasTask, matureSoon, needAll, orderInfo, siteId, specializations) => new Promise(((resolve, reject) => {
  let endpointURL = `${apiURL}?page=${page}&term=${searchTerm}&site_id=${siteId}&specializations=${specializations}`;
  if (orderInfo) {
    endpointURL = `${apiURL}?page=${page}&term=${searchTerm}&order=${orderInfo.order}&direction=${orderInfo.direction}&site_id=${siteId}&specializations=${specializations}`;
  }
  if (locationIds) {
    let location_query = '';
    if (locationIds.length === 0) {
      location_query += 'location_ids[]=';
    }
    locationIds.forEach((x, index) => {
      if (index + 1 < locationIds.length) {
        location_query += `location_ids[]=${x}&`;
      } else {
        location_query += `location_ids[]=${x}`;
      }
    });
    endpointURL = `${endpointURL}&${location_query}`;
  }
  if (categoryId) {
    endpointURL = `${endpointURL}&category_id=${categoryId}`;
  }
  if (hasTask) {
    endpointURL = `${endpointURL}&has_task=${hasTask}`;
  }
  if (matureSoon) {
    endpointURL = `${endpointURL}&mature_soon=${matureSoon}`;
  }
  if (needAll) {
    endpointURL = `${endpointURL}&need_all=${needAll}`;
  }
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchStatementWithInspection = id => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/${id}?with_inspections=true`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));


const fetchStatement = id => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/${id}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const createStatement = params => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}`;
  const formData = new FormData();
  Object.keys(params).forEach((k) => {
    if (params[k] != undefined && params[k] != null && params[k] != 'null') {
      if (k === 'files') {
        params[k].forEach((x) => {
          formData.append('files[]', x, x.name);
        });
      } else if (k === 'location_ids') {
        params[k].forEach((x) => {
          formData.append('location_ids[]', x);
        });
      } else {
        formData.append(k, params[k]);
      }
    }
  });
  fetchData(endpointURL, 'post', formData, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const updateStatement = params => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/${params.id}`;
  const formData = new FormData();
  Object.keys(params).forEach((k) => {
    if (params[k] != undefined && params[k] != null && params[k] != 'null') {
      if (k === 'files') {
        params[k].forEach((x) => {
          formData.append('files[]', x, x.name);
        });
      } else if (k === 'location_ids' || k === 'locations') {
        params[k].forEach((x) => {
          if (x) {
            formData.append('location_ids[]', x.id);
          }
        });
      } else if (k === 'asset_ids') {
        params[k].forEach((x) => {
          formData.append('asset_ids[]', x);
        });
      } else {
        formData.append(k, params[k]);
      }
    }
  });
  fetchData(endpointURL, 'put', formData, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const deleteStatement = id => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/${id}`;
  fetchData(endpointURL, 'delete', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const createBaseState = (params) => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}base_states`;
  fetchData(endpointURL, 'post', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchPreviousBaseStates = page => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}base_states?page=${page}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const fetchPreviousBaseState = id => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}base_states/${id}`;
  fetchData(endpointURL, 'get', null, resolve, reject).catch((error) => {
    reject(error);
  });
}));

const updateBaseState = params => new Promise(((resolve, reject) => {
  const endpointURL = `${ENDPOINT_HOST}base_states/${params.id}`;
  fetchData(endpointURL, 'put', params, resolve, reject).catch((error) => {
    reject(error);
  });
}));

export default {
  fetchStatements,
  fetchStatement,
  createStatement,
  updateStatement,
  deleteStatement,
  fetchStatementWithInspection,
  createBaseState,
  fetchPreviousBaseStates,
  fetchPreviousBaseState,
  updateBaseState,
};



// WEBPACK FOOTER //
// ./src/api/statements.js